// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

const guestCheckoutCheckEmailUrl = "/api/custom/guestCheckout/checkEmail";

export interface CheckGuestEmailApiParameter extends ApiParameter {
    email: string;
}

export interface CheckGuestEmailModel {
    emailExists: boolean;
}

export async function checkGuestEmail(
    parameter: CheckGuestEmailApiParameter,
): Promise<ServiceResult<CheckGuestEmailModel>> {
    try {
        const result = await post<CheckGuestEmailApiParameter, CheckGuestEmailModel>(
            guestCheckoutCheckEmailUrl,
            parameter,
        );
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
